module.exports = __webpack_public_path__ + "media/creativeMedia/panel07-7278b018.png";